// Cambia estos valores y se actualizan en toda la página.
export const siteConfig = {
  checkoutUrl: 'https://paseo-pro.impultienda.ar/checkout', // ← Link de pago
  metaPixelId: '1373694817702913', // ← Pixel de Meta (Facebook / Instagram)
  price: 'USD 14,90',
  priceCurrency: 'USD',
  priceAmount: '14,90',
  priceValue: 14.9, // valor numérico que se envía al pixel
  guaranteeDays: 10,
  supportEmail: 'atencionstockdigital@gmail.com',
}
